<template>
  <b-alert
    show
    variant="info"
    class="mb-0"
    data-cy="billing-permission-notice"
  >
    <strong>An account admin needs to finish this step.</strong>
    Payment, bank and verification details can only be set up by an admin of this account. Ask an
    admin to complete the setup, then check back here.
  </b-alert>
</template>

<script>
/**
 * Stands in for a form that a member without the billing permission cannot use: the backend answers
 * every payment method, KYC and bank details request from them with a 403.
 */
export default {
  name: 'BillingPermissionNotice'
}
</script>
